import { createFileRoute } from "@tanstack/react-router";
import { ApiTokensPage } from "@/features/api-tokens/api-tokens-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/tokeny-api")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: ApiTokensPage,
});
